module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.activeFiltersCount > 0) ? _c('div', {
    staticClass: "active-filters-list"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Valda filter:")]), _vm._v(" "), _c('ul', _vm._l((_vm.activeFilters), function(value, filter) {
    return _c('li', [_c('FilterListItem', {
      attrs: {
        "filter": filter,
        "label": (filter === 'locationId' ? ('Område: ' + _vm.area(value)) : null),
        "value": value
      },
      on: {
        "click": function($event) {
          _vm.awaitFilter();
          _vm.resetAccomodationsFilter(filter)
        }
      }
    })], 1)
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.poolCount > 1) ? _c('span', {
    staticClass: "text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.unitCount))]), _vm._v(" resultat (över " + _vm._s(_vm.poolCount) + " områden),\n      "), _c('span', [_vm._v(_vm._s(_vm.selectedFilterObject.explanation))])]) : _vm._e(), _vm._v(" "), (_vm.poolCount <= 1) ? _c('span', {
    staticClass: "text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.unitCount))]), _vm._v(" resultat\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeFiltersCount > 0 || _vm.$store.state.accomodationsFilter.freeSearch),
      expression: "activeFiltersCount > 0 || $store.state.accomodationsFilter.freeSearch"
    }],
    ref: "resetButton",
    staticClass: "reset-button reset-filter-text",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n        Återställ filter "), _c('icon', {
    attrs: {
      "name": "Reset",
      "scale": 1.3
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sort-filter"
  }, [_c('Dropdown', {
    attrs: {
      "options": _vm.filters,
      "validated": _vm.selectedFilter && _vm.selectedFilter.value,
      "value": _vm.selectedFilter,
      "label": (_vm.selectedFilter && _vm.selectedFilter.value) ? ('Sortering: ' + (_vm.selectedFilter.title)) : 'Sortera efter',
      "with-background": true,
      "bold-label": true,
      "type": "clean"
    },
    on: {
      "changed": _vm.changedSorting,
      "clicked-suffix": function($event) {
        return _vm.changedSorting({})
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bd7d19c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/List/Filter/AccomodationsFilterInfo.vue
// module id = 913
// module chunks = 0